export default {
  hideCompletedEventList: 'Ukryj zakończone wydarzenia',
};
